import React from "react";

import { useNavigate } from "react-router-dom";

import useAuth from "../../config/context/authContext";
import useMainState from "../../config/context/mainStateContext";
import useModal from "../../config/context/modalContext";
import { CafeteriaService } from "../../config/services/CafeteriaService";

import SideMenuDrawer from "../../components/SideMenuDrawer";

import { OnlyChildren } from "../../types/common";
import { CafeteriaType } from "../../types/database";

type DefaultContextType = {
  currentCafeteria: CafeteriaType | null;
  handleGetCafeterias: () => Promise<void>;
  isLoadingCafeterias: boolean;
};

const DefaultContext = React.createContext<DefaultContextType | null>(null);

export function CafeteriaProvider({ children }: OnlyChildren) {
  const navigate = useNavigate();

  const { pushAlert } = useModal();

  const { userEnableToInteract } = useMainState();

  const { currentUserState, currentUserInfo } = useAuth();

  const [currentCafeteria, setCurrentCafeteria] = React.useState<CafeteriaType | null>();

  //

  const CafeteriaOne = CafeteriaService.OneFromUser();

  const handleGetCafeterias = async () => {
    if (!currentUserState?.uid) return;
    const cafeteria = await CafeteriaOne.runRequest(currentUserState?.uid).catch((err) =>
      pushAlert({ type: "error", message: "Erro ao obter lanchonete. " + err.message })
    );

    if (cafeteria) setCurrentCafeteria(cafeteria);
  };

  React.useEffect(() => {
    if (process.env.NODE_ENV === "development") {
      if (currentUserState?.uid) {
        handleGetCafeterias();
      } else if (!userEnableToInteract()) navigate("/");
    }
  }, []);

  //

  const value = {
    currentCafeteria,
    handleGetCafeterias,
    isLoadingCafeterias: CafeteriaOne.isLoading,
  };

  return (
    <DefaultContext.Provider value={value as DefaultContextType}>
      <SideMenuDrawer />
      {children}
    </DefaultContext.Provider>
  );
}

export default function useCafeteria() {
  return React.useContext(DefaultContext) as DefaultContextType;
}
